export const OTB_COLORS = [
  "#f58b4d",
  "#BFBFBF",
  "#9544d2",
  "#12a9b3",
  "#aeaa10",
  "#e52590",
  "#178751",
  "#eb3c3c",
  "#5d62f6",
  "#b2f65d",
  "#f8fa4f",
];